import { render, staticRenderFns } from "./FeedFuture-Modelos.vue?vue&type=template&id=87ef3b30&"
import script from "./FeedFuture-Modelos.vue?vue&type=script&lang=js&"
export * from "./FeedFuture-Modelos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports